import { render } from "./ForeverStudiosLogo.vue?vue&type=template&id=60e1a691"
import script from "./ForeverStudiosLogo.vue?vue&type=script&lang=js"
export * from "./ForeverStudiosLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__